import { AsyncThunkPayloadCreator } from '@reduxjs/toolkit'
import { getCampaignById } from '../../../api/campaign/useFetchCampaign'
import { updateCampaign } from '../../../api/campaign/useEditCampaign'
import { Campaign } from '../../../api/campaign/types'
import { search, SearchCampaignParams } from '../../../api/campaign/useSearchCampaign'
import http from '../../../utils/Http/Http'

export const fetchCampaignDetails: AsyncThunkPayloadCreator<Campaign, string> = async (
	campaignId,
	{ rejectWithValue },
) => {
	try {
		return getCampaignById(campaignId)
	} catch (error) {
		return rejectWithValue(error)
	}
}

export const updateCampaignDetails: AsyncThunkPayloadCreator<
	Campaign,
	{
		campaignId: string
		updates: any
	}
> = async ({ campaignId, updates }, { rejectWithValue }) => {
	try {
		const response = await updateCampaign({ campaignId, ...updates })
		return response.data
	} catch (error) {
		return rejectWithValue(error)
	}
}

export const searchCampaigns: AsyncThunkPayloadCreator<
	{
		campaigns: Campaign[]
		current_page: number
		total_pages: number
		total_records: number
	},
	SearchCampaignParams
> = async (searchParams, { rejectWithValue }) => {
	try {
		return search(searchParams)
	} catch (error) {
		return rejectWithValue(error)
	}
}

export const deleteCampaign: AsyncThunkPayloadCreator<string, string> = async (campaignId, { rejectWithValue }) => {
	try {
		// Inline the API call since deleteCampaign is not exported directly
		const url = `/campaigns/${campaignId}`
		await http({ url, method: 'delete' })
		return campaignId
	} catch (error) {
		return rejectWithValue(error)
	}
}
